//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapActions, mapMutations, mapState} from "vuex";
import {filterMixin} from '@/mixins/filterMixin'
import {gridCodes} from "@/enums/gridCodes";
import {columnSettingMixin} from '@/mixins/columnSettingMixin'
import {columnFormatterMixin} from '@/mixins/columnFormatterMixin'
import MyAccountMenu from "@/frontend/components/page-sections/my-account-menu";

export default {
  name: "my-account",
  components: {MyAccountMenu},
  mixins: [filterMixin, columnSettingMixin,columnFormatterMixin],
  data() {
    return{
      filterVisibility: false,
      headers: [],
    }
  },
  async beforeMount() {
    const redirect = 'my-account';
    if (!this.$auth.loggedIn) {
      await this.$router.push({ path: '/user-login', query: { redirect } });
    }
  },
  async mounted(){
    if (!this.$auth.loggedIn) {
      return
    }
    await this.fetchSalesOrders({
      filters: this.buildFilterString(),
    })
    this.gridCode = gridCodes.SalesOrder
    await this.buildHeaders()
  },
  computed:{
    ...mapState('backoffice/status-tracking/salesOrder', [
      'salesOrders',
      'options',
      'page',
      'totalItems',
    ]),
    tableOptions: {
      get() {
        return this.options
      },
      set(value) {
        this.setOptions({options: value})
      },
    },
  },
  methods: {
    ...mapMutations('backoffice/status-tracking/salesOrder', ['setOptions']),
    ...mapActions('backoffice/status-tracking/salesOrder', [
      'fetchSalesOrders',
    ]),
    ...mapActions('common/reportPrinter', ['printInvoiceReport']),

    applyFilter() {
      this.fetchSalesOrders({
        filters: this.buildFilterString(),
      })
    },
    async onPrintButtonClick(item) {
      const invoiceResponse = await this.$axios.$get(`/invoices?OrderCode=${item.orderCode}`);
      try{
        if(!invoiceResponse || invoiceResponse.items?.length === 0){
          this.$toast.error("No invoice found")
          return
        }
        await this.printInvoiceReport(invoiceResponse.items[0].id)
      }
      catch {
        this.$toast.error("Error while printing invoice report")
      }
    },
    async buildHeaders() {
      let dynamicColumns = this.getDynamicColumns('CP_SALES_ORDERS_ADM')
      dynamicColumns.push({
        sortable: false,
        align: 'center',
        isVisibleInList: true,
        isVisibleForUser: true,
        text: 'Invoice',
        value: 'invoice',
      })
      await this.initializeVisibleHeaders(
        dynamicColumns,
        this.gridCode,
        null,
        null
      )
    }
  }
}
